<template>
  <div>
    <div  class="w3-container flow-padding-top">
      <!--TODO hide this with a seperate value (when a patient is saved and then immediatly printed).   -->
<!--      <p v-if="!isQuickPrint" class="w3-col w-80pc flow-form-inline-input">-->
<!--        <label class="w3-left flow-blue-color flow-padding-bottom">{{-->
<!--          $t("accessType")-->
<!--        }}</label>-->
<!--        <span class="flowselect">-->
<!--          <select v-model="selectedType">-->
<!--            <option v-for="item in accessTypes" :key="item.id" :value="item.value">-->
<!--              {{ $t(item.value) }}-->
<!--            </option>-->
<!--          </select>-->
<!--          <i class="fa fa-chevron-down flow-green-active-color"></i>-->
<!--        </span>-->
<!--      </p>-->
      <p class="w3-col w-80pc flow-form-inline-input">
        <label class="w3-left flow-blue-color flow-padding-bottom">{{
          $t("printer")
        }}</label>
        <span class="flowselect">
          <select v-model="selectedPrinter">
            <option v-for="item in selectItems" :key="item.id" :value="item.id">
              {{ item.id }}
            </option>
          </select>
          <i class="fa fa-chevron-down flow-green-active-color"></i>
        </span>
      </p>
    </div>
    <div class="w3-row">
      <button
        class="
          flow-btn
          w3-btn
          w3-round
          w3-border
          w3-ripple
          w3-round-medium
          w3-left
          w3-margin-right
          w3-margin-top
          w3-large
        "
        @click.prevent="printTicket"
      >
        <i class="fa fa-print w3-text-blue">
           <span><b class="flow-margin-left">{{$t('printTicket')}}</b></span>
        </i>
      </button>
      <button
        class="
          flow-btn
          w3-btn
          w3-round
          w3-border
          w3-ripple
          w3-round-medium
          w3-left
          w3-margin-right
          w3-margin-top
          w3-large
        "
        @click.prevent="closeByButton"
      >
        <i class="fa w3-text-red" :class="isQuickPrint? 'fa-times' : 'fa-arrow-left'">
          <span><b class="flow-margin-left">{{$t('back')}}</b></span>
        </i>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
const frc = Vue.prototype.$frc;
export default {
  data() {
    return {
      selectItems: [],
      selectedPrinter: {},
      accessTypes: [],
      selectedType: {}
    };
  },
  //TODO add isSavePrint
  props: ["accessType","accessControlId", "togglePrint","isQuickPrint","onClose"],
  methods: {
    getAllPrinters() {
      frc.getPrinters().then((response) => {
        this.selectItems = response.data;
        var lastUsedPrinter = this.loadPrinter();
        if(lastUsedPrinter){
          this.selectedPrinter = lastUsedPrinter
        } else {
        this.selectedPrinter = this.selectItems[0].id;
        }
      });
    },
    printTicket() {
      var app = this;
      app.savePrinter();
      if(!app.isQuickPrint){
        app.printSelectedTicket();
      } else {
        app.printQuickTicket();
      }
    },
    printSelectedTicket() {
      var app = this;
          frc.printQRCodeForAccessControl(
          app.accessControlId,
          app.selectedPrinter
        )
        .then((response) => {
          Vue.notifySuccess({
            title: app.$t("printingOn:")+" " + app.selectedPrinter,
          });
          app.togglePrint();
        });
    },
    printQuickTicket(){
      var app = this;
      frc.printQuickTicket(app.selectedPrinter).then(response => {
        Vue.notifySuccess({
            title: app.$t("printingOn:")+" " + app.selectedPrinter,
          });
          app.onClose();
      })
    },
    // getRelatedAccessTypes(){
    //   var app = this;
    //   frc.getAllRelatedAccessTypes(app.accessType).then(response => {
    //     app.accessTypes = response.data;
    //     app.selectedType = app.accessTypes[0].value;
    //   })
    // },
    savePrinter(){
      localStorage.setItem('lastUsedPrinter',this.selectedPrinter);
    },
    loadPrinter(){
      return localStorage.getItem('lastUsedPrinter');
    },
    closeByButton(){
      if(this.isQuickPrint){
        this.onClose();
      } else {
        this.togglePrint();
      }
    }
  },
  mounted() {
    this.getAllPrinters();
    // this.getRelatedAccessTypes();
  },
};
</script>

<style scoped>
label {
  margin-right: 10px;
}
</style>
